import React, { FC, useState } from 'react';
import Button from 'components/Button/Index';
import { IAssessmentPopup } from 'core/interface/assessmentPopup';
import { IMe } from 'core/interface/me';
import { useSelector } from 'react-redux';
import { JobService } from 'services/jobs/job';

import './Index.scss';

const AssessmentPopup: FC<IAssessmentPopup> = ({ t, onBackClick }) => {
  const me = useSelector((state: IMe) => state.user).user;
  const [loading, setLoading] = useState<boolean>(false);

  const handleBack = (): void => {
    onBackClick(false);
  };

  const handleStart = async (): Promise<void> => {
    getAssessments();
  };

  const getAssessments = async (): Promise<void> => {
    setLoading(true);
    try {
    const res = await JobService.postAssessments(me.id);
    if (res.test_logon_url) window.location.href = res.test_logon_url;
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="assessment">
      <p className="assessment-paragraph">
        {t("With 48 competencies to explore, you'll have the opportunity to delve deep within yourself and discover what truly drives you. This isn't just a test; it's an exploration of your potential, one that will match you with the perfect role within our organization. Remember, there are no 'right' or 'wrong' answers.")}
      </p>
      <div className="assessment__buttons">
        <Button
          onClick={handleBack}
          t={t}
          className="assessment__buttons-btn back"
          title="Back"
        />
        <Button
          isLoading={loading}
          onClick={handleStart}
          t={t}
          className="assessment__buttons-btn start"
          title="Take Your Assessment Test"
        />
      </div>
    </div>
  );
};

export default AssessmentPopup;
